import React from 'react';
import BackButtonCollapseDashProvider from 'context/dash/BackButtonCollapseDash';
import DetailVisibleProvider from 'context/dash/DetailVisible';
import ShowAllEventsProvider from 'context/dash/ShowAllEvents';
import DashContainer from 'modules/dashboard/_common/DashContainer';
import CustomersPage from 'modules/dashboard/producer/customers/CustomersPage';

export default function DashProducerCustomers() {
    return (
        <BackButtonCollapseDashProvider>
            <ShowAllEventsProvider>
                <DetailVisibleProvider>

                    <DashContainer title='Clientes'>
                        <CustomersPage />
                    </DashContainer>

                </DetailVisibleProvider>
            </ShowAllEventsProvider>
        </BackButtonCollapseDashProvider>
    );
}
